import { render, staticRenderFns } from "./settingsDrawer.vue?vue&type=template&id=3aef2988"
import script from "./settingsDrawer.vue?vue&type=script&lang=js"
export * from "./settingsDrawer.vue?vue&type=script&lang=js"
import style0 from "./settingsDrawer.vue?vue&type=style&index=0&id=3aef2988&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports